import {
  CALCULATION_PROCESS_END,
  CALCULATION_PROCESS_START,
  SYSTEM_CALCULATION_REQUEST,
} from 'actions/designer/calculationActions'
import { RootState } from 'types/state'

export const SET_LAST_COMMAND_TIMESTAMP = 'SET_LAST_COMMAND_TIMESTAMP'

export type LastCommandTimestampReducerState = {
  value: number
}
const initialState: LastCommandTimestampReducerState = {
  value: 0,
}

export function lastCommandTimestampReducer(
  state: LastCommandTimestampReducerState = initialState,
  action: any
): LastCommandTimestampReducerState {
  switch (action.type) {
    case SYSTEM_CALCULATION_REQUEST:
    case CALCULATION_PROCESS_START:
    case CALCULATION_PROCESS_END:
      // Update timestamp when calculator actions occur
      return {
        ...state,
        // @ts-ignore - ignore type error for undos array element access
        value: window.editor?.history?.undos?.at(-1)?.timeStamp || undefined,
      }
    default:
      return state
  }
}

export const lastCommandTimestampSelectors = {
  value: (state: RootState) => {
    return state.designer.lastCommandTimestamp.value
  },
}
